import { useEffect } from "react";
import { Tooltip } from "antd";
import moment from "moment";
import { removerDuplicadosPorOperacao } from "../../../ModalOrdemServicoMatriz/utils";
import { limitarCaracteres } from "../../../ModalPlanejamentoOperacoes/utils";
import useStore from "../../../OrdemServico/hooks/useStore";
import useModalOrdemServicoMatriz from "../../../OrdemServico/hooks/useModalOrdemServicoMatriz";
import {
  MatrizScrollContainer,
  MatrizTable,
  TableHeaderCell,
  OperationHeader,
  OperationHeaderContent,
  OperationHeaderTitle,
  SelectAllColumnBtn,
  TableBodyCell,
  OperationCell,
  OperationCard,
  OperationCardDate,
  OperationCardInputCheck,
  OperationCardSequence,
  OperationCardStatus,
  EmptyCell,
} from "./styles";
import { IconOSNew } from "../../../MapInfoSemaforo/IconsMap";

interface OperacoesTableProps {
  operacoes: any[];
  isEdit?: boolean;
  ordemServico: {
    id: string | null;
    code: number | null;
  };
  listData: any[];
  isFetching: boolean
}

function OperacoesTable({ operacoes, isEdit, ordemServico, listData, isFetching }: OperacoesTableProps) {

  const {
    classesOperacoes,
    planoOperacionalOperacaoTalhaoIds,
    setClassesOperacoes,
    setPlanoOperacionalOperacaoTalhaoIds,
    setIsMatrizSubmitAllowed,
  } = useStore();

  const {
    hiddenBlockeds,
    hiddenCompleteds,
  } = useModalOrdemServicoMatriz();

  const operationHeaderList = removerDuplicadosPorOperacao(operacoes);
  const [header] = operationHeaderList;
  const codigosComOperacoes = new Set(
    operacoes.map((operacao) => String(operacao.codigo))
  );
  const talhoesSemOperacoes = listData.filter(
    (talhao) => !codigosComOperacoes.has(String(talhao.codigo))
  );
  const emptyColumnsCount =
    header?.planoOperacionalOperacaoTalhao?.length || 5;

  function checkAmount(quantidades: any[], selecionados: any[]) {
    return selecionados.some(selecionado => {
      const item = quantidades.find(item => item.classe === selecionado.classe);
      return item && selecionado.quantidade < item.quantidade;
    });
  }

  function handleCheckCombination() {
    const { classesOperacoes, planoOperacionalOperacaoTalhaoIds } = useStore.getState();

    const talhoes = operacoes?.flatMap(o => o?.planoOperacionalOperacaoTalhao);

    const quantidadePorClasse = classesOperacoes.map(classe => {
      const quantidade = talhoes.filter(t => t.operacaoClasse === classe && !t.bloqueado).length ?? 0;
      return { classe, quantidade }
    });

    const selecionados = talhoes.filter(talhao => planoOperacionalOperacaoTalhaoIds.includes(talhao?.planoOperacionalOperacaoTalhaoId));
    const selecionadosPorClasse = classesOperacoes.map(classe => {
      const quantidade = selecionados.filter(t => t.operacaoClasse === classe && !t.bloqueado).length ?? 0;
      return { classe, quantidade }
    });

    const result = checkAmount(quantidadePorClasse, selecionadosPorClasse);
    setIsMatrizSubmitAllowed(!result);
  }

  function handleSelect(checked: boolean, talhao: any) {
    const id = talhao.planoOperacionalOperacaoTalhaoId;
    const classeOperacao = talhao.operacaoClasse;
    const talhoes = operacoes?.flatMap(o => o?.planoOperacionalOperacaoTalhao);
    const selecionados = talhoes.filter(t => planoOperacionalOperacaoTalhaoIds.includes(t?.planoOperacionalOperacaoTalhaoId));
    const porClasse = selecionados.filter(t => t.operacaoClasse === classeOperacao);

    if (checked) {
      const classes = Array.from(new Set([...classesOperacoes, classeOperacao]));
      setClassesOperacoes(classes);

      const insertItem = talhoes.find(t => t.planoOperacionalOperacaoTalhaoId === id);
      if (!insertItem) return;

      const idsMesmaClasseMesmoTalhao = talhoes
        .filter(
          t =>
            t.planoOperacionalOperacaoTalhaoId &&
            t.planoOperacionalOperacaoTalhaoId !== id &&
            t.operacaoClasse === insertItem.operacaoClasse &&
            t.numeroTalhao === insertItem.numeroTalhao
        )
        .map(t => t.planoOperacionalOperacaoTalhaoId);

      let novosIds = planoOperacionalOperacaoTalhaoIds.filter(
        itemId => !idsMesmaClasseMesmoTalhao.includes(itemId)
      );

      if (!novosIds.includes(insertItem.planoOperacionalOperacaoTalhaoId)) {
        novosIds = [...novosIds, insertItem.planoOperacionalOperacaoTalhaoId];
      }

      setPlanoOperacionalOperacaoTalhaoIds(novosIds);
      return;
    }

    setClassesOperacoes(
      porClasse.length === 1 ? classesOperacoes.filter(p => p !== classeOperacao) : classesOperacoes
    );
    setPlanoOperacionalOperacaoTalhaoIds(planoOperacionalOperacaoTalhaoIds.filter(p => p !== id));
  }

  function getOperacoesDaColuna(index: number, colClasse?: string) {
    return operacoes
      .map((t: any) => t.planoOperacionalOperacaoTalhao?.[index])
      .filter(
        (t: any) =>
          t &&
          !t.isPlaceholder &&
          ((!t.bloqueado && t.areaDisponivelPorcentagem > 0) || (!t.bloqueado && isEdit)) &&
          t.planoOperacionalOperacaoTalhaoId
          && (!colClasse || t.operacaoClasse === colClasse)
      );
  }

  function handleSelectAllFromColumn(checked: boolean, index: number, colClasse: string) {
    const talhoesFiltered = getOperacoesDaColuna(index, colClasse);
    const ids = talhoesFiltered.map((t: any) => t.planoOperacionalOperacaoTalhaoId);
    const classesTalhoes = Array.from(new Set(talhoesFiltered.map((t: any) => t.operacaoClasse)));
    if (checked) {
      const classes = Array.from(new Set([...classesOperacoes, ...classesTalhoes]));
      let idsAtuais = planoOperacionalOperacaoTalhaoIds;

      if (isEdit) {
        const idsOutrasColunasMesmaClasse = (header?.planoOperacionalOperacaoTalhao ?? [])
          .flatMap((value: any, colIndex: number) => {
            if (colIndex === index || value.operacaoClasse !== colClasse) return [];
            return getOperacoesDaColuna(colIndex, colClasse).map(
              (t: any) => t.planoOperacionalOperacaoTalhaoId
            );
          });

        idsAtuais = idsAtuais.filter(id => !idsOutrasColunasMesmaClasse.includes(id));
      }

      const arr = Array.from(new Set([...idsAtuais, ...ids]));
      setClassesOperacoes(classes);
      setPlanoOperacionalOperacaoTalhaoIds(arr);
      return;
    }
    setClassesOperacoes(classesOperacoes.filter(p => !classesTalhoes.includes(p)));
    setPlanoOperacionalOperacaoTalhaoIds(planoOperacionalOperacaoTalhaoIds.filter(o => !ids.includes(o)));
  }

  function getStatusText(status: string) {
    if (status === "AguardandoAtivacao") {
      return "Aguardando Ativação";
    }
    if (status === "ExecutadaParcialmente") {
      return "Executada Parcialmente";
    }
    return status;
  }

  function getStatusColor(status: string) {
    if (status === "Executada") {
      return "#4caf50";
    }
    if (status === "Atrasada") {
      return "#f44336";
    }
    if (status === "ExecutadaParcialmente") {
      return "#ff9800";
    }
    return "#2196f3";
  }

  useEffect(() => {
    handleCheckCombination();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [planoOperacionalOperacaoTalhaoIds]);

  return (
    <MatrizScrollContainer>
      <MatrizTable>
        <thead>
          <tr>
            <TableHeaderCell>Talhão</TableHeaderCell>
            {
              !header && !isFetching && Array.from({ length: 5 }, (_, index) => index)?.map((_, index: number) => (
                <OperationHeader key={index}>
                  <OperationHeaderContent>
                    <Tooltip title="Talhão sem Plano Vinculado">
                      <OperationHeaderTitle title="Sem Plano">Sem Plano</OperationHeaderTitle>
                      <SelectAllColumnBtn>
                        <input
                          type="checkbox"
                          checked={false}
                          disabled={true}
                        />
                        Todos
                      </SelectAllColumnBtn>
                    </Tooltip>
                  </OperationHeaderContent>
                </OperationHeader>
              ))
            }
            {header?.planoOperacionalOperacaoTalhao?.map((value, index) => {
              const { operacaoClasse } = value;

              const operacoesColuna = getOperacoesDaColuna(index, operacaoClasse);
              const columnKeys = operacoesColuna.map(
                (t: any) => t.planoOperacionalOperacaoTalhaoId
              );
              const todosExistem =
                columnKeys.length > 0 &&
                columnKeys.every(item => planoOperacionalOperacaoTalhaoIds.includes(item));

              return (
                <OperationHeader key={index}>
                  <OperationHeaderContent>
                    <Tooltip title={operacaoClasse}>
                      <OperationHeaderTitle title={operacaoClasse}>{limitarCaracteres(operacaoClasse, 23)}</OperationHeaderTitle>
                    </Tooltip>
                    <SelectAllColumnBtn>
                      <input
                        type="checkbox"
                        onChange={(e) => handleSelectAllFromColumn(e.target.checked, index, operacaoClasse)}
                        checked={todosExistem}
                        disabled={columnKeys.length === 0}
                      />
                      Todos
                    </SelectAllColumnBtn>
                  </OperationHeaderContent>
                </OperationHeader>
              );
            })}
          </tr>
        </thead>
        <tbody>
          {
            !isFetching && talhoesSemOperacoes.map((operacao) => (
              <tr key={operacao.codigo}>
                <TableBodyCell>
                  <div>T{operacao?.codigo}</div>
                  <div>{operacao?.areaPlantadaHa} ha</div>
                </TableBodyCell>
                {Array.from({ length: emptyColumnsCount }, (_, index) => index).map((index) => (
                  <OperationCell key={index}>
                    <OperationCard disabled={true}><EmptyCell>-</EmptyCell></OperationCard>
                  </OperationCell>
                ))}
              </tr>
            ))
          }
          {operacoes?.sort((a, b) => Number(a.codigo) - Number(b.codigo))?.map((operacao, index) => (
            <tr key={index}>
              <TableBodyCell>
                <div>T{operacao?.codigo}</div>
                <div>{operacao?.areaPlantadaHa} ha</div>
              </TableBodyCell>
              {operacao.planoOperacionalOperacaoTalhao?.map((talhao: any, index: number) => {
                const isPlaceholder = talhao.isPlaceholder;
                const status = talhao.status;
                const executado = talhao?.areaDisponivelPorcentagem <= 0;
                let bloqueado = talhao.bloqueado;
                const possuiVinculo = talhao?.ordensServico?.length > 0;
                const data = talhao?.periodoDataInicio && talhao?.periodoDataFim ? `${moment.utc(talhao?.periodoDataInicio).format("DD/MM/YYYY")} à ${moment.utc(talhao?.periodoDataFim).format("DD/MM/YYYY")}` : moment.utc(talhao?.dataProgramada).format("DD/MM/YYYY");
                const dataExecucao = talhao?.dataExecucao ? moment.utc(talhao?.dataExecucao).format("DD/MM/YYYY") : null;
                const nameDate = talhao?.status === "ExecutadaParcialmente" ? "Data Exec. Parcial:" : "Data Executada:";
                const dataSemAno = talhao?.periodoDataInicio && talhao?.periodoDataFim ? `${moment.utc(talhao?.periodoDataInicio).format("DD/MM")} à ${moment.utc(talhao?.periodoDataFim).format("DD/MM")}` : moment.utc(talhao?.dataProgramada).format("DD/MM");
                const colorStatus = getStatusColor(status);

                const proximoOperacao = operacao.planoOperacionalOperacaoTalhao?.[index + 1];

                const validationError = talhao?.error && !bloqueado && !isPlaceholder;

                const isChecked = isEdit && possuiVinculo ? talhao.ordensServico.includes(ordemServico.code) : false;

                if (talhao.operacaoClasse === proximoOperacao?.operacaoClasse && talhao?.ordensServico?.length > 0 && proximoOperacao?.ordensServico?.length > 0) {
                  bloqueado = true;
                }

                const sequencia = talhao.sequencia;
                const operacoesSimilares = operacao.planoOperacionalOperacaoTalhao?.filter((item: any) => item.planoOperacional === talhao?.planoOperacional);
                const operacoesAnteriores = operacoesSimilares.filter((item: any) => item.sequencia < sequencia);
                const codigoOS = ordemServico.code;

                if (operacoesAnteriores.some((item: any) => item.ordensServico.includes(codigoOS))) {
                  bloqueado = true;
                }

                return (
                  <Tooltip
                    overlayStyle={{ maxWidth: 440 }}
                    title={!isPlaceholder ? (
                      <>
                        <p>{talhao?.operacaoCodigo} - {talhao?.operacao}</p>
                        <p>Plano: {talhao?.planoOperacional ?? "-"}</p>
                        <p>Data Programada: {data}</p>
                        {possuiVinculo && dataExecucao && <p>{nameDate} {dataExecucao}</p>}
                        {possuiVinculo && <p>O.S.: {talhao?.ordensServico?.join(", ")}</p>}
                        <p>Área Disponível: {talhao?.areaDisponivelPorcentagem?.toFixed(2)}%: {talhao.areaDisponivelHa?.toFixed(2)}ha</p>
                      </>
                    ) : "Sem Planejamento"}>
                    <OperationCell key={index}>
                      {(hiddenCompleteds && status === "Executada") || (hiddenBlockeds && bloqueado && !executado) || isPlaceholder ? (
                        <OperationCard disabled={bloqueado} error={validationError}><EmptyCell>-</EmptyCell></OperationCard>
                      ) : (
                        <OperationCard disabled={bloqueado} error={validationError}>
                          {possuiVinculo && (
                            <IconOSNew width={16} height={18} heightSpec={1} style={{ position: 'absolute', left: 10, top: 10 }} />
                          )}
                          {(isChecked || !executado) && (
                            <OperationCardInputCheck
                              type="checkbox"
                              disabled={bloqueado}
                              onChange={(e) => handleSelect(e.target.checked, talhao)}
                              checked={planoOperacionalOperacaoTalhaoIds.includes(talhao.planoOperacionalOperacaoTalhaoId)}
                            />
                          )}
                          <OperationCardSequence>{talhao.index}ª</OperationCardSequence>
                          <OperationCardDate>{dataSemAno}</OperationCardDate>
                          <OperationCardStatus backgroundColor={colorStatus}>{getStatusText(status)}</OperationCardStatus>
                        </OperationCard>
                      )}
                    </OperationCell>
                  </Tooltip>
                );
              })}
            </tr>
          ))}
        </tbody>
      </MatrizTable>
    </MatrizScrollContainer>
  );
}

export default OperacoesTable
